/**
 * Created by andrey on 20.02.2026
 *
 * https://dev.vk.com/ru/bridge/VKWebAppStorageSet
 * https://apiok.ru/dev/methods/rest/storage/storage.set
 * 1000 key-values, 1000 set+get per hour,
 * 4096 value length limit, 2236 limit for JSON serialized string (for double serialization)
 */

class TestTransportAdapter {
    saveData(data, options, onSuccess) {
        new ConnectorActionPlayer([
            (f) => {
                if (options.syncout) {
                    f();
                    return;
                }

                this.loadData((storedData) => {
                    data = Object.assign(storedData, data);
                    f();
                });
            },

            (f) => {
                localStorage.setItem(`${connector.config.projectId}_testSync`, JSON.stringify(data));
                f();
            }
        ]).play(onSuccess);
    }

    loadSession(onSuccess) {
        this.loadData((data) => onSuccess(data && data.session));
    }

    loadData(onSuccess) {
        const item = localStorage.getItem(`${connector.config.projectId}_testSync`);
        const data = item ? JSON.parse(item) : {};

        onSuccess(data);
    }
}
